import React, { useCallback, useMemo, useState } from 'react';
import clsx from 'clsx';
import { MathUtils } from '@printu/geom';
import { useConnect } from 'app/views/hooks/useConnect';
import { useResize } from 'app/views/hooks/useResize';
import { toDomPx } from 'app/utils/DOM';
import { call } from 'app/utils/function';
import { SlideImageView } from '../../project/SlideImageView';
const Consts = {
    defaultPadding: { x: 22, y: 22 },
};
const EmptyRect = { x: 0, y: 0, width: 0, height: 0 };
export function Preview(props) {
    const { className, padding = Consts.defaultPadding, itemSelector, Content = SlideImageView, children, } = props;
    const viewRef = React.useRef(null);
    const [designRect, setDesignRect] = useState(EmptyRect);
    const item = useConnect(state => itemSelector(state));
    const viewBox = useMemo(() => ({
        x: 0,
        y: 0,
        width: item.width,
        height: item.height,
    }), [item]);
    const containerStyles = useMemo(() => ({
        left: toDomPx(designRect.x),
        top: toDomPx(designRect.y),
        width: toDomPx(designRect.width),
        height: toDomPx(designRect.height),
    }), [designRect]);
    const getElement = useCallback(() => viewRef.current, [viewRef]);
    const onResize = useCallback((bounds) => {
        if (!item) {
            return;
        }
        const availableWidth = bounds.width - padding.x * 2;
        const availableHeight = bounds.height - padding.y * 2;
        const resizeRequired = item.width > availableWidth || item.height > availableHeight;
        const fitSize = resizeRequired
            ? MathUtils.getFitSize(item.width, item.height, availableWidth, availableHeight)
            : { width: item.width, height: item.height };
        setDesignRect({
            x: (bounds.width - fitSize.width) * 0.5,
            y: (bounds.height - fitSize.height) * 0.5,
            width: fitSize.width,
            height: fitSize.height,
        });
    }, [item, padding, setDesignRect]);
    useResize(getElement, onResize);
    return (React.createElement("div", { className: clsx('preview-view', className), ref: viewRef },
        React.createElement("div", { className: "preview-view__container", style: containerStyles }, item && (React.createElement(React.Fragment, null,
            React.createElement(Content, { id: item.id, viewBox: viewBox }),
            call(children, item, designRect))))));
}
